function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

class ProductTemplate extends HTMLElement {
    constructor() {
        super();

    }

    connectedCallback() {
        try { this.recalculateStepNumbers(); } catch(e) { console.warn('recalculateStepNumbers:', e); }
        try { this.initMedia(); } catch(e) { console.warn('initMedia:', e); }
        try { this.initSticky(); } catch(e) { console.warn('initSticky:', e); }

        const productModal = this.querySelector('.product-modal-product');
        if (productModal) {
            productModal.addEventListener('click', (e) => {
                productModal.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
            });

            this.querySelectorAll('.product-media__slide img').forEach((item) => {
                item.addEventListener('click', (e) => {
                    productModal.classList.add('active');
                    document.body.classList.add('overflow-hidden');
                    const modalImg = productModal.querySelector('img');
                    if (modalImg) modalImg.src = e.currentTarget.src;
                });
            });
        }

        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        const modalAlcool = document.querySelector('.modal__alcool');
        if (modalAlcool) {
            document.body.classList.add('overflow-modal');
            document.querySelectorAll('[data-close-modal]').forEach((elem) => {
                elem.addEventListener('click', function () {
                    modalAlcool.classList.remove('active');
                    document.body.classList.remove('overflow-modal');
                });
            });
        }

        try { this.calculateShipping(); } catch(e) { console.warn('calculateShipping:', e); }
        try { this.initLowStock(); } catch(e) { console.warn('initLowStock:', e); }

        this.querySelectorAll('.bundle-content__item-details').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const url = e.currentTarget.getAttribute('data-product-url');
                this.openProductModal(url);
            });
        });

        this.querySelectorAll('[data-upsell-toggle]').forEach(btn => {
            btn.addEventListener('click', () => {
                const card = btn.closest('.product-form__upsell-card');
                const desc = card ? card.querySelector('.product-form__upsell-card-description') : null;
                if (!desc) return;
                btn.classList.toggle('active');
                desc.slideToggle(250);
            });
        });

        this.querySelectorAll('.product-form__upsell-card').forEach(card => {
            card.style.cursor = 'pointer';
            card.addEventListener('click', (e) => {
                if (e.target.closest('[data-upsell-toggle]') || e.target.closest('.product-form__upsell-item__variant') || e.target.closest('.product-form__upsell-textarea')) return;
                const upsellItem = card.closest('.product-form__upsell-item');
                if (!upsellItem) return;
                const checkbox = upsellItem.querySelector('.product-form__upsell-input');
                if (!checkbox) return;
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new Event('change'));
            });
        });

        this.querySelectorAll('.product-form__upsell-input').forEach(checkbox => {
            checkbox.addEventListener('change', () => this.updateButtonPrice());
        });

        const addBtn = this.querySelector('.product-info__add-button button');
        if (addBtn) {
            this._updatingPrice = false;
            new MutationObserver(() => {
                if (this._updatingPrice) return;
                const priceEl = this.querySelector('.product-info__price[data-base-price]');
                if (priceEl) this.updateButtonPrice();
            }).observe(addBtn, { childList: true, subtree: true });

            addBtn.addEventListener('click', (e) => {
                this.submitForm(e);
            });
        }

        const stickyBtn = this.querySelector('.product-form__sticky-submit-button button');
        if (stickyBtn) {
            stickyBtn.addEventListener('click', (e) => {
                this.submitForm(e);
            });
        }

        try { this.switsherQuantity(); } catch(e) { console.warn('switsherQuantity:', e); }

        const defaultQuantity = document.querySelector('.product-quantity__container [for="quantity-5"]');
        if (defaultQuantity) defaultQuantity.click();
    }

    calculateShipping() {
        const shippingIcon = this.querySelector(".sidecart-form__icon");
        if (!shippingIcon) return;

        let shipping_date = new Date();
        let shipping_delay = parseInt(shippingIcon.getAttribute("data-shipping-delay"));

        if (isNaN(shipping_delay)) {
            const cartIcon = this.querySelector(".cart-form__icon");
            if (cartIcon) {
                shipping_delay = parseInt(cartIcon.getAttribute("data-shipping-delay"));
            }
        }
        if (isNaN(shipping_delay) || shipping_delay <= 0) return;

        for (var i = 0; i < shipping_delay; i++) {
            shipping_date.setDate(shipping_date.getDate() + 1);
            if (shipping_date.getDay() == 6) {
                shipping_date.setDate(shipping_date.getDate() + 2);
            }
            if (shipping_date.getDay() == 0) {
                shipping_date.setDate(shipping_date.getDate() + 1);
            }
        }

        let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
            weekday: "short",
            day: "numeric",
            month: "long",
        });

        document.querySelectorAll(".sidecart-form__icon").forEach(el => {
            if (el.innerHTML.indexOf("[date]") > -1) {
                el.innerHTML = el.innerHTML.replace("[date]", shipping_date_format);
            }
        });

        document.querySelectorAll(".cart-form__icon").forEach(el => {
            if (el.innerHTML.indexOf("[date]") > -1) {
                el.innerHTML = el.innerHTML.replace("[date]", shipping_date_format);
            }
        });
    }


    initLowStock() {
        const inventoryScript = this.querySelector('[data-variant-inventory]');
        if (!inventoryScript) return;

        try {
            this._variantInventory = JSON.parse(inventoryScript.textContent);
        } catch(e) { return; }

        const reassurance = this.querySelector('.product-info__reassurance');
        if (!reassurance) return;
        this._lowStockThreshold = parseInt(reassurance.getAttribute('data-low-stock-threshold')) || 0;
        if (this._lowStockThreshold <= 0) return;

        // Initial check
        const currentInput = this.querySelector('input[name="id"]');
        if (currentInput) {
            this.updateLowStock(currentInput.value);
        }

        // Listen for variant changes via input radio/label clicks
        this.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
            input.addEventListener('change', () => {
                const variantId = this.querySelector('input[name="id"]');
                if (variantId) {
                    setTimeout(() => this.updateLowStock(variantId.value), 50);
                }
            });
        });

        // Also observe the hidden input[name="id"] for changes
        const hiddenInput = this.querySelector('input[name="id"]');
        if (hiddenInput) {
            const observer = new MutationObserver(() => {
                this.updateLowStock(hiddenInput.value);
            });
            observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
        }
    }

    updateLowStock(variantId) {
        if (!this._variantInventory || !this._lowStockThreshold) return;

        const reassurance = this.querySelector('.product-info__reassurance');
        if (!reassurance) return;

        const data = this._variantInventory[variantId];
        const isLowStock = data
            && data.managed === 'shopify'
            && data.quantity <= this._lowStockThreshold;

        const dot = reassurance.querySelector('.jc-rounded-full');
        const circle = reassurance.querySelector('.delivery-icon circle');
        const lowStockLabel = reassurance.querySelector('.product-info__low-stock');
        const separator = reassurance.querySelector('.product-info__reassurance-separator');

        if (isLowStock) {
            if (dot) dot.classList.add('jc-rounded-full--low-stock');
            if (circle) circle.setAttribute('fill', '#D53417');
            if (lowStockLabel) lowStockLabel.style.display = '';
            if (separator) separator.style.display = '';
        } else {
            if (dot) dot.classList.remove('jc-rounded-full--low-stock');
            if (circle) circle.setAttribute('fill', '#00B67A');
            if (lowStockLabel) lowStockLabel.style.display = 'none';
            if (separator) separator.style.display = 'none';
        }
    }

    formatMoney(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }

    updateButtonPrice() {
        const priceEl = this.querySelector('.product-info__price[data-base-price]');
        if (!priceEl) return;
        const basePrice = Number(priceEl.getAttribute('data-base-price'));
        let upsellTotal = 0;
        this.querySelectorAll('.product-form__upsell-input').forEach(cb => {
            if (cb.checked) upsellTotal += Number(cb.getAttribute('data-upsell-price') || 0);
        });
        const newPrice = this.formatMoney(basePrice + upsellTotal);
        if (priceEl.textContent.trim() === newPrice) return;
        this._updatingPrice = true;
        priceEl.textContent = newPrice;
        requestAnimationFrame(() => { this._updatingPrice = false; });
    }

    getUpsellItems() {
        const items = [];
        this.querySelectorAll('.product-form__upsell-input').forEach((checkbox) => {
            if (!checkbox.checked) return;
            const upsellItem = checkbox.closest('.product-form__upsell-item');
            const variantRadio = upsellItem.querySelector('.product-form__upsell-item__variant input:checked');
            const upsellId = variantRadio ? Number(variantRadio.value) : Number(checkbox.value);
            const textarea = upsellItem.querySelector('.product-form__upsell-textarea');
            const message = textarea ? textarea.value.trim() : '';
            const item = { id: upsellId, quantity: 1 };
            if (message) {
                item.properties = { '_message': message };
            }
            items.push(item);
        });
        return items;
    }

    getBuilderData() {
        const builderContainer = this.querySelector('[data-product-builder]');
        if (!builderContainer || !builderContainer._builder) return null;
        return builderContainer._builder.getBuilderData();
    }

    submitForm(e) {
        e.preventDefault();

        // Check for builder mode
        const builderData = this.getBuilderData();
        if (builderData && builderData.variantId) {
            const cartItem = {
                id: builderData.variantId,
                quantity: 1,
                properties: {}
            };

            if (builderData.coverColor) {
                cartItem.properties['Couleur coffret'] = builderData.coverColor;
            }

            if (builderData.flavors.length > 0) {
                cartItem.properties['Contenu'] = builderData.contentString;
                cartItem.properties['_ids'] = builderData.idsString;
            }

            let items = [cartItem];

            // Add cover product variant as separate cart item, linked via _bundle_id
            if (builderData.coverVariantId) {
                const bundleId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
                cartItem.properties['_bundle_id'] = bundleId;
                items.push({
                    id: builderData.coverVariantId,
                    quantity: 1,
                    properties: { '_bundle_id': bundleId }
                });
            }

            items = items.concat(this.getUpsellItems());

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items }),
            })
                .then(response => {
                    if (!response.ok && builderData.coverVariantId) {
                        // Retry without cover variant if it caused the error
                        const fallbackItems = items.filter(item => item.id !== builderData.coverVariantId);
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: fallbackItems }),
                        }).then(r => r.json());
                    }
                    return response.json();
                })
                .then(data => {
                    this.openSideCart();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            return;
        }

        const variantEl = this.querySelector('[data-variant-id-current]:checked') || this.querySelector('[data-variant-id-current]');
        if (!variantEl) return;
        let variant_id = Number(variantEl.getAttribute('data-variant-id-current'));
        if (!variant_id) return;

        const quantityEl = this.querySelector('[data-current-quantity]:checked');
        let quantity = quantityEl ? Number(quantityEl.value) : 1;
        if (!quantity) quantity = 1;

        let items = [{ id: variant_id, quantity: quantity }];
        items = items.concat(this.getUpsellItems());

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
        })
            .then(response => response.json())
            .then(data => {
                this.openSideCart();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    openSideCart() {
        const sideCart = document.querySelector('side-cart');
        if (!sideCart) return;
        sideCart.renderCart();
        sideCart.openCart();
        if (typeof jouerSon === 'function') jouerSon();
    }

    initSticky() {
        const productFormSticky = this.querySelector(".product-form__sticky");
        const productInfoAddButton = this.querySelector(".product-info__add-button");
        if (!productFormSticky || !productInfoAddButton) return;
        if (this.querySelector('.product-form__sticky-variants-content-pack')) {
            this.querySelectorAll(".product-form__sticky-variants-content-pack label").forEach((item) => {
                item.addEventListener("click", () => {
                    this.querySelectorAll(".product-form__sticky-variants-content-pack label").forEach((inner) => {
                        const wrapper = inner.closest('.bundle-content__item-variant');
                        if (wrapper) wrapper.classList.remove("active");
                    });
                    const wrapper = item.closest('.bundle-content__item-variant');
                    if (wrapper) wrapper.classList.add("active");
                    const target = this.querySelector('.product-form__container label[for="' + item.getAttribute('data-current-variant-handle') + '"]');
                    if (target) target.click();
                })
            });
        } else {
            this.querySelectorAll(".product-variant__current-sticky [data-current-variant-handle]").forEach((item) => {
                item.addEventListener("click", () => {
                    this.querySelectorAll(".product-variant__current-sticky [data-current-variant-handle]").forEach((inner) => {
                        if (inner) inner.classList.remove("active");
                    });
                    item.classList.add("active");
                    const target = this.querySelector('.product-form__input [data-handle="' + item.getAttribute('data-current-variant-handle') + '"] + label');
                    if (target) target.click();
                })
            });
        }
        const stickyVariants = this.querySelector('.product-form__sticky-variants');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    productFormSticky.classList.remove("product-form__sticky-active");
                    document.body.classList.remove("product-form__sticky-active-body");
                    if (stickyVariants) stickyVariants.classList.remove('product-form__sticky-variants-active');
                    document.body.classList.remove("product-form__sticky-active-variant-body");
                } else {
                    productFormSticky.classList.add("product-form__sticky-active");
                    document.body.classList.add("product-form__sticky-active-body");
                }
            });
        });

        observer.observe(productInfoAddButton);

        const stickyToggle = this.querySelector('.product-form__sticky-toggle-content');
        if (stickyToggle && stickyVariants) {
            stickyToggle.addEventListener('click', () => {
                stickyVariants.classList.toggle('product-form__sticky-variants-active');
                document.body.classList.toggle("product-form__sticky-active-variant-body");
            });
        }

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('product-form__sticky-active-variant-body') && stickyVariants) {
                stickyVariants.classList.remove('product-form__sticky-variants-active');
                document.body.classList.remove("product-form__sticky-active-variant-body");
            }
        });
    }

    updateBasePriceFromText(priceText) {
        const priceEl = this.querySelector('.product-info__price[data-base-price]');
        if (!priceEl) return;
        const cleaned = priceText.replace(/[^\d,\.]/g, '').replace(',', '.');
        const cents = Math.round(parseFloat(cleaned) * 100);
        if (!isNaN(cents)) {
            priceEl.setAttribute('data-base-price', cents);
            this.updateButtonPrice();
        }
    }

    switsherQuantity() {
        document.querySelectorAll('product-template .product-quantity__container-item').forEach((item) => {
            item.addEventListener('click', () => {
                const input = item.querySelector('input');
                if (!input) return;
                let id = input.getAttribute('data-current-quantity');
                const stickyInput = document.querySelector(`.product-form__sticky-variants .product-quantity__container-item [data-current-quantity="${id}"]`);
                if (stickyInput) stickyInput.setAttribute('checked', 'checked');
                const goodPriceEl = item.querySelector('.good-price');
                if (!goodPriceEl) return;
                const goodPrice = goodPriceEl.textContent;
                document.querySelectorAll('[variant-price-change]').forEach((elem) => {
                    elem.textContent = goodPrice;
                });
                const unitEl = document.querySelector('[variant-price-change-unit]');
                if (unitEl) unitEl.textContent = goodPrice;
                this.updateBasePriceFromText(goodPrice);
            });
        });

        document.querySelectorAll('.product-form__sticky-variants .product-quantity__container-item').forEach((item) => {
            item.addEventListener('click', () => {
                const input = item.querySelector('input');
                if (!input) return;
                let id = input.getAttribute('data-current-quantity');
                const mainInput = document.querySelector(`product-template .product-quantity__container-item [data-current-quantity="${id}"]`);
                if (mainInput) mainInput.setAttribute('checked', 'checked');
                const goodPriceEl = item.querySelector('.good-price');
                if (!goodPriceEl) return;
                const goodPrice = goodPriceEl.textContent;
                document.querySelectorAll('[variant-price-change]').forEach((elem) => {
                    elem.textContent = goodPrice;
                });
                const unitEl = document.querySelector('[variant-price-change-unit]');
                if (unitEl) unitEl.textContent = goodPrice;
                this.updateBasePriceFromText(goodPrice);
            });
        });
    }

    recalculateStepNumbers() {
        const allSteps = this.querySelectorAll('[data-builder-step]');
        let stepNum = 0;
        allSteps.forEach(step => {
            const isHidden = step.classList.contains('builder-cover') && !step.classList.contains('builder-cover--visible');
            if (isHidden) return;
            stepNum++;
            const numberEl = step.querySelector('[data-builder-step-number]');
            if (numberEl) numberEl.textContent = stepNum;
        });
    }

    initMedia() {
        const swiperEl = this.querySelector('.swiper-media');
        if (!swiperEl) return;
        new Swiper(swiperEl, {
            direction: 'horizontal',
            loop: false,
            slidesPerView: "auto",
        });
    }

    async openProductModal(url) {
        const modal = document.querySelector('.modal__product-detail');
        const overlay = document.querySelector('.modal__product-detail-overlay');
        if (!modal || !overlay) return;

        const response = await fetch(url);
        const html = await response.text();
        modal.innerHTML = html;

        modal.getBoundingClientRect();

        modal.classList.add('active');
        overlay.classList.add('active');
        document.body.classList.add('overflow-hidden');

        const swiperEl = modal.querySelector('.product-modal-detail__swiper-container .swiper');
        if (swiperEl) {
            new Swiper(swiperEl, {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 6,
                scrollbar: {
                    el: swiperEl.querySelector('.swiper-scrollbar'),
                    draggable: true
                }
            });
        }

        modal.querySelectorAll('.faq-item-title').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const currentItem = e.currentTarget.parentNode;
                if (!currentItem) return;

                modal.querySelectorAll('.product-collapse__base-wraper.faq-item-active').forEach(openItem => {
                    if (openItem !== currentItem) {
                        openItem.classList.remove('faq-item-active');
                        const faqClose = openItem.querySelector('.faq-close');
                        const faqText = openItem.querySelector('.faq-item-text');
                        if (faqClose) faqClose.classList.remove('faq-display-none');
                        if (faqText) faqText.slideUp(250);
                    }
                });

                const faqClose = e.currentTarget.querySelector('.faq-close');
                const faqText = currentItem.querySelector('.faq-item-text');
                if (faqClose) faqClose.classList.toggle('faq-display-none');
                currentItem.classList.toggle('faq-item-active');
                if (faqText) faqText.slideToggle(250);
            });
        });

        const closeBtn = modal.querySelector('[data-close-product-modal]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.closeProductModal());
        overlay.addEventListener('click', () => this.closeProductModal());
    }

    closeProductModal() {
        const modal = document.querySelector('.modal__product-detail');
        const overlay = document.querySelector('.modal__product-detail-overlay');
        if (modal) modal.classList.remove('active');
        if (overlay) overlay.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    toggleFaqItem(e) {
        const currentItem = e.currentTarget.parentNode;
        if (!currentItem) return;

        this.querySelectorAll('.product-collapse__base-wraper.faq-item-active').forEach((openItem) => {
            if (openItem !== currentItem) {
                openItem.classList.remove('faq-item-active');
                const faqClose = openItem.querySelector('.faq-close');
                const faqText = openItem.querySelector('.faq-item-text');
                if (faqClose) faqClose.classList.remove('faq-display-none');
                if (faqText) faqText.slideUp('250');
            }
        });

        const faqClose = e.currentTarget.querySelector(".faq-close");
        const faqText = currentItem.querySelector(".faq-item-text");
        if (faqClose) faqClose.classList.toggle("faq-display-none");
        currentItem.classList.toggle("faq-item-active");
        if (faqText) faqText.slideToggle("250");
    }

}

customElements.define('product-template', ProductTemplate);